import { storeManager } from './storeManager.js';

export const setStore = store => {
  storeManager.store = store;
};